import z from 'zod';
import { productIdValue } from '../value-objects/product-id';
import { stripePriceLookupKeyValue, stripeProductIdValue, subscriptionPlanIdValue, } from '../value-objects/stripe-ids';
import { domainValue, firmTypologyValue, subscriptionPaymentMethodValue, subscriptionPlanValue, } from '../value-objects/subscription-enums';
const nullableStripePriceLookupKeyValue = z.union([
    stripePriceLookupKeyValue,
    z.null(),
]);
export const productPricesSchema = z.object({
    annual: nullableStripePriceLookupKeyValue,
    daily: nullableStripePriceLookupKeyValue,
    monthly: nullableStripePriceLookupKeyValue,
}).refine(prices => prices.daily !== null
    || prices.monthly !== null
    || prices.annual !== null, { message: 'Product must declare at least one price lookup key' });
export const productSchema = z.object({
    billingPortalConfigurationId: z.string().trim().min(1).nullable(),
    domain: domainValue,
    firmTypology: firmTypologyValue,
    id: productIdValue,
    plan: subscriptionPlanValue,
    planId: subscriptionPlanIdValue,
    prices: productPricesSchema,
    stripeProductId: stripeProductIdValue,
    subscriptionPaymentMethod: subscriptionPaymentMethodValue,
});
export const parseProduct = (value) => productSchema.parse(value);
export const productsSchema = z.array(productSchema);
//# sourceMappingURL=product.js.map